<template>
    <Popup :showPopup="showUsagePopup" :wide="true" header="Call Box Usage Policy" :noCloseX="true" :attentionContent="true" @close-popup="$emit('close-policy-pop')">
        <template v-slot:content>
            <p class='disclaimer'>
                By putting a check mark next to I AGREE and clicking on SUBMIT or using the API or Call Box Services, you represent and warrant that the owners of the phone numbers you initiate messages to through the Call Box Services have consented or otherwise opted-in to the receipt of such messages and broadcasts as required by any applicable law or regulation. 
                You agree that you will include clear opt-out/unsubscribe information on your messages or broadcasts when required to do so by any applicable law or regulation and otherwise adhere to the Consumer Best Practices Guidelines promulgated by the Mobile Marketing Association, if applicable to your messages. 
                You further agree that any individuals requesting “Do-Not-Call” (“DNC”) status shall immediately be placed on your DNC accounts list and you further agree that you will not initiate any subsequent messages or broadcasts to any individuals after they request DNC status. 
                You agree to familiarize yourself with and abide by all applicable local, state, national and international laws and regulations and are solely responsible for all acts or omissions that occur under your account, including without limitation the content of the messages and broadcasts that you create and initiate through the Call Box Services. 
                Without limiting the foregoing, you agree to familiarize yourself with the legalities of any messages, calls, broadcasts, and campaigns transmitted through the Call Box Services by visiting the following websites:
            </p>
            <p class='disclaimer'>
                Federal Trade Commission, <a class='link' href='https://www.ftc.gov' target="_blank">https://www.ftc.gov</a>
            </p>
            <p class='disclaimer'>
                Federal Communications Commission, <a class='link' href='https://www.fcc.gov' target="_blank">https://www.fcc.gov</a>
            </p>
            <p class='disclaimer'>
                DoNotCall Registry Info, <a class='link' href='https://www.donotcall.gov' target="_blank">https://www.donotcall.gov</a>
            </p>
            <p class='disclaimer'>
                The Telephone Consumer Protection Act (“TCPA”), the Federal Trade Commission, the Federal Communications Commission, the DNC list registry rules ( <a href='https://www.donotcall.gov' class='link' target="_blank">https://www.donotcall.gov</a>) and various state laws, rules and regulations place restrictions on certain types of phone calls and text messages. 
                Call Box is in no way attempting to interpret any laws, rules, or regulations.
            </p>
            <p class='disclaimer'>
                This information is provided merely as a courtesy and is not intended to replace your responsibility to familiarize yourself with and abide by the legal requirements pertaining to your messages, broadcasts and campaigns prior to using the Call Box API or Services. 
                You are ultimately responsible to make your own informed decisions regarding your messages, broadcasts, and campaigns and will be the one to control all aspects of determining how, when, and to whom communication is made. 
                You agree to indemnify, defend, and hold Call Box harmless for any breach of the Terms, any violation of law, or any negligence, gross, or intentional misconduct carried out by your Call Box user.
            </p>
        </template>

        <template v-slot:attention-content>
            <div class='checkwrap'>
                <div class="checkbox">
                    <input id='ToS' v-model='agreedTo' type="checkbox">
                    <i class="zmdi zmdi-square-o"></i>
                    <i class="zmdi zmdi-check-square"></i>
                </div>
                <label for='ToS'>I Agree</label>
          </div>
        </template>

        <template v-slot:buttons>
            <button :disabled='!agreedTo' @click="$emit('submit-policy')">submit</button>
        </template>
    </Popup>
</template>

<script>
import Popup from '@/components/Popup';

export default {
    name: 'UsagePolicyPopup',
    props: ['showUsagePopup'],
    components: { Popup },
    data: function(){
        return {
            agreedTo: false
        }
    }
}
</script>